import { z } from "zod";
import { businessMetadataShape } from "@/domain/business-metadata";

// Transport guard only. The backend's shared/context.py owns full semantic validation.
export const contextSchema = z
  .object({
    business: z
      .object({ ...businessMetadataShape, name: z.string().min(1), primaryLanguage: z.string(), currency: z.string() })
      .passthrough(),
    products: z.array(z.record(z.string(), z.unknown())),
    services: z.array(z.record(z.string(), z.unknown())),
    pricing: z.array(z.record(z.string(), z.unknown())),
    dimensions: z.array(z.record(z.string(), z.unknown())),
    knowledge: z.array(z.record(z.string(), z.unknown())),
    discoveryGuidance: z.array(z.string()),
    assumptions: z.array(z.unknown()),
    unknowns: z.array(z.unknown()),
    extensions: z.array(z.record(z.string(), z.unknown())),
  })
  .passthrough();
export type JourneyContext = z.infer<typeof contextSchema>;
export function readDeployedContext(content: string): JourneyContext | null {
  try {
    return contextSchema.parse(JSON.parse(content));
  } catch {
    return null;
  }
}
